import { createContext, useContext, type ReactNode } from "react";

import type { AppRole, AuthIdentity } from "./roles";

export interface AuthState {
  configured: boolean;
  authenticated: boolean;
  identity: AuthIdentity | null;
  roles: readonly AppRole[];
  canViewAnalyst: boolean;
  canLaunch: boolean;
  canOperate: boolean;
}

const AuthContext = createContext<AuthState | null>(null);

export function AuthStateProvider({
  value,
  children,
}: {
  value: AuthState;
  children: ReactNode;
}) {
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthState {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth must be used inside AuthGate");
  return value;
}
